import type { AssetPack } from '../../../../types/AssetPack';
import { app } from '../App';
import { TransitionType } from '../enums/TransitionType';
import TransitionScene from './TransitionScene';

export default abstract class BaseScene extends Phaser.Scene {
  public static transitionEvents = {
    TransitionCovering: 'transitionCovering',
    TransitionCovered: 'transitionCovered',
    TransitionUncovering: 'transitionUncovering',
    TransitionUncovered: 'transitionUncovered'
  } as const;

  private assetPack: AssetPack | undefined;

  constructor(key: string) {
    super({ key: key });
  }

  public init(data: object) {
    // this.assetPack = assetPack;
    console.log(`${this.scene.key} Data!`, data);
  }

  public preload() {
    console.log(`Preload ${this.scene.key}!`);

    app.AssetManager.loadAssetsForScene(this);

    // console.log(this.cache);
    // console.log(this.textures);
  }

  /**
   * Only called when at least one file has loaded.
   */
  public postload() {
    console.log(`Postload ${this.scene.key}!`);
    // console.log(this.cache);
    // console.log(this.textures);

    // Compare all manifests.
    // Unload missing items.
  }

  public create() {
    app.AssetManager.unloadAssets(this);
    app.AssetManager.resetPostLoad();
  }

  public startTransition(transitionScene: TransitionScene, config: Phaser.Types.Scenes.SceneTransitionConfig) {
    if (transitionScene.TransitionType == TransitionType.SceneCoverScene) this.startTransitionWithCover(config);
    if (transitionScene.TransitionType == TransitionType.SceneToScene) this.startTransitionScene(config);
  }

  /**
   * Creates a third scene to cover the transition between two scenes while waiting for the new scene to do any preload.
   *
   * @param config
   * @returns
   */
  public startTransitionWithCover(config: Phaser.Types.Scenes.SceneTransitionConfig): boolean {
    let targetScene = this.scene.get(config.data.transitionData.nextScene);
    let transitionScene = this.scene.get(config.target);

    if (!targetScene || !transitionScene) return false;

    let isSameScene: boolean = this.scene.key == config.data.transitionData.nextScene;

    transitionScene.events.once(BaseScene.transitionEvents.TransitionCovered, () => {
      if (targetScene.sys.isSleeping()) targetScene.sys.wake(config.data);
      else if (isSameScene && targetScene.sys.isActive()) targetScene.scene.restart(config.data);
      else this.scene.manager.start(config.data.transitionData.nextScene, config.data);

      if (!isSameScene) this.scene.manager.stop(this.scene.key);
    });

    if (transitionScene.sys.isSleeping()) transitionScene.sys.wake(config.data);
    else this.scene.manager.start(config.target, config.data);

    return true;
  }

  public startTransitionScene(config: Phaser.Types.Scenes.SceneTransitionConfig): boolean {
    let transitionScene = this.scene.get(config.target);

    if (!transitionScene) return false;

    let isSameScene: boolean = this.scene.key == config.data.transitionData.nextScene;

    if (transitionScene.sys.isSleeping()) transitionScene.sys.wake(config.data);
    else this.scene.manager.start(config.target, config.data);

    transitionScene.events.once(BaseScene.transitionEvents.TransitionCovered, () => {
      this.scene.manager.stop(this.scene.key);
      this.sys.isTransitioning
    });

    return true;
  }

  public shutdown() {
    console.log(`Shutting Down Scene ${this.scene.key}!`);
  }

  public destroy() {
    console.log(`Destroying Scene ${this.scene.key}!`);
  }

  protected finish() {}

  // abstract unload: (assetPack: AssetPack) => void;
}
